/*
  Cuenta de clientes (Zendelaya, fase 3)

  Con sesión iniciada, guarda los favoritos y el perfil de "Encuentra tu talla" en la cuenta del cliente
  (campos zendelaya.favoritos y zendelaya.perfil_talla), a través del app proxy /apps/zendelaya (servidor: _zendelaya-app/worker.js).
  Sin sesión todo sigue funcionando solo en este navegador.

  - Se carga ANTES de zendelaya-favoritos.js y zendelaya-talla.js (todos con defer, en ese orden):
    así, al abrir la página, el navegador ya tiene los datos de la cuenta cuando esos scripts arrancan.
  - Favoritos: se unen los del navegador con los de la cuenta. Los quitados quedan registrados ("quitados")
    para que no reaparezcan desde otro dispositivo.
  - Perfil: gana el más reciente y se sube solo. La autorización es el aviso del paso 1 de Encuentra tu talla:
    el perfil lleva "consentimiento" (fecha y texto), que el servidor exige y guarda como constancia.
  - Al cerrar sesión se borra la copia de este navegador (equipos compartidos).
  - Datos de la página: <script type="application/json" id="zd-cuenta-datos"> (snippets/zendelaya-cuenta-config.liquid).
*/
(function () {
  if (window.ZendelayaCuenta) return;

  var FAV = 'zd-favoritos';
  var PERFIL = 'zd-perfil-talla';
  var ESTADO = 'zd-cuenta';
  var MAX_PRENDAS = 200;
  var MAX_LOOKS = 100;
  var MAX_QUITADOS = 300;
  var DIAS_QUITADOS = 180;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('zd-cuenta-datos').textContent) || {}; } catch (e) {}
  var textos = cfg.textos || {};

  function leerLS(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function escribirLS(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ------------------------------------------------------------ Unión de datos (igual que en _zendelaya-app/worker.js) */
  function txt(v, max) { return typeof v === 'string' ? v.slice(0, max) : ''; }
  function num(v) { var n = Number(v); return isFinite(n) && n > 0 ? Math.round(n) : 0; }
  function enlace(v) { var s = txt(v, 600); return /^(\/[^/]|https:\/\/|\/\/)/.test(s) ? s : ''; }

  function limpiarFavoritos(d) {
    var out = { v: 1, prendas: [], looks: [], quitados: [], actualizado: 0 };
    if (!d || typeof d !== 'object') return out;
    function item(x, tipo) {
      if (!x || typeof x !== 'object' || !txt(x.handle, 255)) return null;
      var i = { handle: txt(x.handle, 255), nombre: txt(x.nombre, 255), imagen: enlace(x.imagen), url: enlace(x.url), fecha: num(x.fecha) };
      if (tipo === 'prenda') { i.color = txt(x.color, 100); i.variante = txt(String(x.variante || ''), 30); }
      return i;
    }
    if (Array.isArray(d.prendas)) d.prendas.forEach(function (x) { var i = item(x, 'prenda'); if (i) out.prendas.push(i); });
    if (Array.isArray(d.looks)) d.looks.forEach(function (x) { var i = item(x, 'look'); if (i) out.looks.push(i); });
    if (Array.isArray(d.quitados)) d.quitados.forEach(function (q) {
      if (q && (q.t === 'prenda' || q.t === 'look') && txt(q.k, 400)) out.quitados.push({ t: q.t, k: txt(q.k, 400), f: num(q.f) });
    });
    out.actualizado = num(d.actualizado);
    return out;
  }
  function claveFav(tipo, x) { return tipo === 'look' ? x.handle : x.handle + '|' + (x.color || ''); }

  function unirFavoritos(a, b, ahora) {
    a = limpiarFavoritos(a);
    b = limpiarFavoritos(b);
    var limite = (ahora || Date.now()) - DIAS_QUITADOS * 864e5;
    var quitados = {};
    a.quitados.concat(b.quitados).forEach(function (q) {
      var k = q.t + ':' + q.k;
      if (!quitados[k] || q.f > quitados[k].f) quitados[k] = q;
    });
    var out = { v: 1, prendas: [], looks: [], quitados: [], actualizado: Math.max(a.actualizado, b.actualizado) };
    [['prenda', 'prendas', MAX_PRENDAS], ['look', 'looks', MAX_LOOKS]].forEach(function (c) {
      var tipo = c[0], lista = c[1], max = c[2], m = {};
      a[lista].concat(b[lista]).forEach(function (x) {
        var k = claveFav(tipo, x);
        if (!m[k] || x.fecha > m[k].fecha) m[k] = x;
      });
      out[lista] = Object.keys(m)
        .map(function (k) { return m[k]; })
        .filter(function (x) { var q = quitados[tipo + ':' + claveFav(tipo, x)]; return !q || x.fecha > q.f; })
        .sort(function (x, y) { return y.fecha - x.fecha; })
        .slice(0, max);
    });
    out.quitados = Object.keys(quitados)
      .map(function (k) { return quitados[k]; })
      .filter(function (q) { return q.f >= limite; })
      .sort(function (x, y) { return y.f - x.f; })
      .slice(0, MAX_QUITADOS);
    return out;
  }
  function mismosFavoritos(a, b) {
    var f = function (d) { d = limpiarFavoritos(d); return JSON.stringify([d.prendas, d.looks, d.quitados]); };
    return f(a) === f(b);
  }

  /* ------------------------------------------------------------ Estado de este navegador */
  var estado = leerLS(ESTADO) || {};
  var activo = !!cfg.activo;
  var cliente = cfg.cliente ? String(cfg.cliente) : '';
  var aplicando = false;

  function guardarEstado() { escribirLS(ESTADO, estado); }
  function borrarCopiaLocal() {
    escribirLS(FAV, null);
    escribirLS(PERFIL, null);
    escribirLS(ESTADO, null);
    estado = {};
  }
  function avisarFavoritos() {
    aplicando = true;
    try {
      if (window.ZendelayaFavoritos) window.ZendelayaFavoritos.sincronizar();
      document.dispatchEvent(new CustomEvent('zendelaya:favoritos', { detail: leerLS(FAV), origen: 'cuenta' }));
    } finally { aplicando = false; }
  }

  /* Perfil local como documento { perfil, actualizado } (incluye el borrado) */
  function perfilLocal() {
    var p = leerLS(PERFIL);
    if (p) return { perfil: p, actualizado: num(p.actualizado) || 1 };
    if (estado.perfilBorrado) return { perfil: null, actualizado: estado.perfilBorrado };
    return null;
  }
  function aplicarPerfil(remoto) {
    if (!remoto) return;
    if (remoto.perfil) {
      var p = remoto.perfil;
      p.actualizado = remoto.actualizado;
      escribirLS(PERFIL, p);
      delete estado.perfilBorrado;
    } else {
      escribirLS(PERFIL, null);
      estado.perfilBorrado = remoto.actualizado;
    }
    guardarEstado();
  }
  /* Documento del perfil para el servidor (con la constancia de autorización del paso 1) */
  function docPerfil(p) {
    return { v: 1, perfil: p, actualizado: num(p.actualizado) || Date.now(), consentimiento: p.consentimiento || undefined };
  }

  /* ------------------------------------------------------------ Envío al servidor */
  var cola = {};
  var temporizador = null;

  function programarEnvio(parte, datos, inmediato) {
    cola[parte] = datos;
    clearTimeout(temporizador);
    temporizador = setTimeout(enviar, inmediato ? 0 : 800);
  }
  function enviar() {
    clearTimeout(temporizador);
    if (!cola.favoritos && !cola.perfil) return Promise.resolve();
    var cuerpo = JSON.stringify(cola);
    cola = {};
    return fetch(cfg.proxy + '/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      keepalive: cuerpo.length < 60000,
      body: cuerpo
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d.favoritos) {
        /* Lo que respondió el servidor ya incluye los otros dispositivos: se une con lo local por si cambió mientras tanto */
        var local = leerLS(FAV);
        var unido = unirFavoritos(local, d.favoritos);
        if (!mismosFavoritos(local, unido)) {
          unido.actualizado = Date.now();
          escribirLS(FAV, unido);
          avisarFavoritos();
        }
      }
      if (d.perfil) {
        var loc = perfilLocal();
        if (!loc || d.perfil.actualizado > loc.actualizado) aplicarPerfil(d.perfil);
      }
    }).catch(function (e) {
      /* Sin conexión o app no instalada: los datos siguen en el navegador y se suben en el próximo cambio o visita */
      estado.pendiente = true;
      guardarEstado();
      if (window.console) console.warn('[Zendelaya cuenta] No se pudo guardar en la cuenta:', e && e.message);
    });
  }

  function subirPerfil(doc, inmediato) {
    programarEnvio('perfil', doc, inmediato);
  }

  /* ------------------------------------------------------------ Arranque (antes que favoritos y talla) */
  function iniciar() {
    if (!activo) return;

    if (!cliente) {
      /* Sin sesión: si este navegador tenía datos de una cuenta, se cerró sesión → se borra la copia */
      if (estado.cliente) borrarCopiaLocal();
      return;
    }
    if (estado.cliente && estado.cliente !== cliente) borrarCopiaLocal();
    estado.cliente = cliente;

    /* Favoritos: unión de lo local con lo de la cuenta */
    var localFav = leerLS(FAV);
    var remotoFav = cfg.favoritos || null;
    var unido = unirFavoritos(localFav, remotoFav);
    if (localFav || remotoFav) {
      unido.actualizado = Math.max(unido.actualizado, 1);
      escribirLS(FAV, unido);
    }
    if ((localFav && !mismosFavoritos(unido, remotoFav)) || estado.pendiente) programarEnvio('favoritos', unido);

    /* Perfil: gana el más reciente (también el que se llenó sin sesión: el aviso ya decía que se guarda en la cuenta) */
    var remoto = cfg.perfil || null;
    var local = perfilLocal();
    if (remoto && (!local || remoto.actualizado >= local.actualizado)) aplicarPerfil(remoto);
    else if (local && (!remoto || local.actualizado > remoto.actualizado)) {
      if (local.perfil) subirPerfil(docPerfil(local.perfil));
      else if (remoto && remoto.perfil) subirPerfil({ v: 1, perfil: null, actualizado: local.actualizado });
    }
    delete estado.pendiente;
    guardarEstado();

    /* Cambios hechos en esta página */
    document.addEventListener('zendelaya:favoritos', function () {
      if (aplicando) return;
      programarEnvio('favoritos', leerLS(FAV));
    });
    document.addEventListener('zendelaya:perfil-talla', function (e) {
      var p = e.detail && e.detail.perfil;
      if (!p) {
        /* Borrado: también en la cuenta (sin dejar datos ni permiso) */
        var ts = Date.now();
        estado.perfilBorrado = ts;
        guardarEstado();
        subirPerfil({ v: 1, perfil: null, actualizado: ts }, true);
        return;
      }
      delete estado.perfilBorrado;
      guardarEstado();
      subirPerfil(docPerfil(p));
    });
    /* Antes de salir de la página, lo pendiente se envía */
    window.addEventListener('pagehide', function () { if (cola.favoritos || cola.perfil) enviar(); });
  }

  iniciar();

  window.ZendelayaCuenta = {
    activo: activo,
    conSesion: function () { return activo && !!cliente; },
    loginUrl: cfg.login_url || '/account/login',
    textos: textos,
    unirFavoritos: unirFavoritos
  };
})();
